import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';

import Section from '../shared/Section';
import './carjaune.css';
import { ArrowUpRight } from 'react-feather';
import { Fichier_3, Fichier_1, Fichier_2 } from './../../assets/img/carjaune';


const Carjaune = (): React.JSX.Element => {
    const { t } = useTranslation();

    return (
        <>
            <Section className="section-etude py-5">
                <Row>
                    <Col xs={12} lg={6} className="text-center">
                        <h4 dangerouslySetInnerHTML={{ __html: t('Pages.Carjaune.Title')! }}></h4>
                    </Col>
                    <Col xs={12} lg={6}>
                        <div className="p-3">
                            <p className='case-study-desc'>{t('Pages.Carjaune.SubTitle')} </p>
                        </div>
                    </Col>
                </Row>
            </Section>
            <div className='background-image carjaune'></div>
            <Section className='case-study'>
                <Row className='justify-content-center'>
                    <Col xs={12} md={10}>
                        <div className='center-box'>
                            <h4 dangerouslySetInnerHTML={{ __html: t('Pages.Carjaune.Title2')! }}></h4>
                            <p>{t('Pages.Carjaune.Description1')}</p>
                            <ArrowUpRight className='icon' size={48} />
                        </div>
                    </Col>
                </Row>
                <Row className='text-center py-3'>
                    <h4 dangerouslySetInnerHTML={{ __html: t('Pages.Carjaune.Title3')! }}></h4>
                    <Col xs={12} md={6} lg={4}>
                        <div className='block'>
                            <img src={Fichier_1} alt={t('Pages.Carjaune.Perspective')} style={{ width: '120px' }} />
                            <p>{t('Pages.Carjaune.Perspective')} </p>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <div className='block'>
                            <img src={Fichier_2} alt={t('Pages.Carjaune.Frequentation')} style={{ width: '120px' }} />
                            <p>{t('Pages.Carjaune.Frequentation')} </p>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <div className='block'>
                            <img src={Fichier_3} alt={t('Pages.Carjaune.Qualite')} style={{ width: '120px' }} />
                            <p>{t('Pages.Carjaune.Qualite')} </p>
                        </div>
                    </Col>
                </Row>
            </Section>
        </>
    );
};

export default Carjaune;